

export abstract class ValidationMessageData {

    public static customErrorMessages: { [key: string]: string } =
        {
            'idNum': ' {value} לא תקין ל{label} ',
            'required': '  {label} שדה חובה',
            // 'minlength': 'minlength',
            // 'maxlength': 'maxlength',
            // 'min': 'min',
            // 'max': 'max',
            'defualt': 'ערך לא תקין '
        }


}
